<!-- eslint-disable antfu/top-level-function -->

<script setup lang="ts">
import { NakedImage as DatocmsNakedImage, StructuredText as DatocmsStructuredText } from "vue-datocms";

const props = defineProps({
  data: {} as any,
});

// https://www.datocms.com/docs/nuxt/rendering-structured-text-fields
// https://www.datocms.com/docs/structured-text/dast#block
// https://www.datocms.com/docs/nuxt/managing-images
const renderBlock = ({ record }: { record: any }) => {
  if (record._modelApiKey === "image_block" || record.__typename === "SingleImageRecord") {
    return h("div", { class: "mb-xl" }, [h(DatocmsNakedImage, { data: record.image.responsiveImage })]);
  }

  return h(
    "div",
    {},
    [
      h("p", {}, "Don't know how to render a block!"),
      h("pre", {}, JSON.stringify(record, null, 2)),
    ],
  );
};
</script>

<template>
  <div class="structured-content">
    <DatocmsStructuredText :data="props.data" :render-block="renderBlock" />
  </div>
</template>

<style scoped>

</style>
